import React, { useState } from 'react';
import ApplicationModal from '../components/ApplicationModal';

const Careers = () => {
  const [isApplicationModalOpen, setIsApplicationModalOpen] = useState(false);

  const handleDownloadApplication = () => {
    const link = document.createElement('a');
    link.href = 'https://washuttle-public-access.s3.us-west-2.amazonaws.com/APPLICATION-DOT.pdf';
    link.download = 'WaShuttle-Application.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openApplicationModal = () => {
    setIsApplicationModalOpen(true);
  };

  const closeApplicationModal = () => {
    setIsApplicationModalOpen(false);
  };

  return (
    <div className="careers-page">
      <div className="services-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>Join Our Team</h1>
        </div>
      </div>

      {/* Section 1: Career Opportunities - white background */}
      <section className="careers-content" style={{backgroundColor: "white"}}>
        <div className="container">
          <div className="careers-description">
            <h2>Career Opportunities</h2>
            <p>Looking for caring people who want to help others. Join our team of dedicated professionals providing essential transportation services while exploring the beauty of Washington state.</p>
            
            <div className="mission-statement">
              <p>Driving for us will grant you a new perspective of our beautiful state. From bustling cities to old highways that snake their way through our beautiful forests, enjoy the beauty of our state while getting paid to do it.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2: Requirements - light background */}
      <section className="careers-content" style={{backgroundColor: "#f8f9fa"}}>
        <div className="container">
          <div className="careers-description">
            <div className="requirements-grid">
              <div className="requirements-section">
                <h3>Basic Requirements</h3>
                <ul>
                  <li>Must be at least 25 years of age</li>
                  <li>Clean driving record</li>
                  <li>Must live in the area applied for</li>
                  <li>Ability to read, write, and speak fluent English</li>
                  <li>Must have computer with printer</li>
                  <li>Must have a cell phone</li>
                </ul>
              </div>

              <div className="requirements-section">
                <h3>Physical Requirements</h3>
                <ul>
                  <li>Ability to perform wheelchair securement</li>
                  <li>Must be physically able to stretch, twist, reach, bend</li>
                  <li>Must be able to periodically lift up to 50 pounds</li>
                  <li>Capable of performing repetitive motions</li>
                  <li>Must have a safe place to keep a vehicle at residence</li>
                </ul>
              </div>

              <div className="requirements-section">
                <h3>Compliance Requirements</h3>
                <ul>
                  <li>Pre-Employment and ongoing random drug/alcohol testing</li>
                  <li>State fingerprint background checks required</li>
                  <li>Must be willing to travel to nearest training site</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 3: Important Notice and Buttons - white background */}
      <section className="careers-content" style={{backgroundColor: "white"}}>
        <div className="container">
          <div className="careers-description">
            <div className="compliance-notice">
              <h3>Important Notice</h3>
              <p>Employment is contingent upon passing a drug and alcohol screening test at an approved testing facility. As our company falls under federal Department of Transportation Guidelines, we require the test results to be negative for Marijuana. We are exempt from Washington state legislation concerning Marijuana use due to being labeled as a "safety-sensitive" position by the Federal Transit Authority.</p>
            </div>
            
            <div className="careers-actions">
              <button onClick={handleDownloadApplication} className="btn btn-primary">
                Download Application Form
              </button>
              <a 
                href="https://www.indeed.com/cmp/Sky-Harbor-Shuttle-LLC/jobs" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn btn-secondary"
              >
                View Open Positions on Indeed
              </a>
            </div>
            
            <div className="upload-application">
              <button onClick={openApplicationModal} className="btn btn-primary">
                Submit Application Online
              </button>
            </div>
          </div>
        </div>
      </section>
      
      <ApplicationModal isOpen={isApplicationModalOpen} onClose={closeApplicationModal} />
    </div>
  );
};

export default Careers; 